import React, { useEffect, useState } from "react";
import Left_panel from "./Left_panel";
import Sub_header from "./Sub_header";
import { List, arrayMove } from "react-movable";
import axios from "axios";
import exportValue from "../apiconfig";
import Swal from 'sweetalert2'
const Carousel_setup = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [tempImages, setTempImages] = useState([]); // temp reorder list
  const [file, setFile] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) homeSection.classList.toggle("sidebar-closed");
  };

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 5000
})

  // Load images
  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    const res = await axios.get(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/fetch_carousel_images`,
      { headers: exportValue.headers }
    );
    setImages(res.data);
    setTempImages(res.data); // reset temp list
  };

  // Upload new image
  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);
    await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/carousel_add`,
      formData,
      { headers: exportValue.headers }
    );
    setFile(null);
    fetchImages();
  };

  // Delete image
  const handleDelete = async (id) => {
    await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/delete_carousel`,
      { id },
      { headers: exportValue.headers }
    );
    fetchImages();
  };

  const handleReset = async () => {
    await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/reset_carousel_settings`,{},
      { headers: exportValue.headers }
    );
    Toast.fire({
        background: "#e63900",
        type: 'success',
        title: "Updated successfully!",
        color: "white"
    });
  };

  // Save order (when Update button clicked)
  const saveOrder = async () => {
    await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/reorder_carousel`,
      { orderedIds: tempImages.map((img) => img._id) },
      { headers: exportValue.headers }
    );
    setImages(tempImages); // update main list
    // alert("Order updated successfully!");
    Toast.fire({
        background: "#e63900",
        type: 'success',
        title: "Order updated successfully!",
        color: "white"
    });
  };

  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section className="home-section">
        <Sub_header />

        {/* Upload */}
        <div className="mb-4 mt-2 d-flex align-items-center">
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            className="form-control w-auto"
          />
          <button className="btn btn-primary ms-2" onClick={handleUpload}>
             Add Image
          </button>

          <button className="btn btn-primary ms-2" onClick={handleReset}>
             Reset All Customer Setting 
          </button>
        </div>

        {/* Drag and Drop List */}
        <div className="card shadow-sm">
          <div className="card-header bg-light fw-bold d-flex justify-content-between align-items-center">
            <span>Carousel Images (Drag to Reorder)</span>
            <button className="btn btn-success btn-sm" onClick={saveOrder}>
               Update Order
            </button>
          </div>
          <div className="card-body p-0">
            <List
              values={tempImages}
              onChange={({ oldIndex, newIndex }) =>
                setTempImages(arrayMove(tempImages, oldIndex, newIndex))
              }
              renderList={({ children, props }) => (
                <ul
                  {...props}
                  className="list-group list-group-flush"
                  style={{ cursor: "grab" }}
                >
                  {children}
                </ul>
              )}
              renderItem={({ value, props, index }) => (
                <li
                  {...props}
                  className="list-group-item d-flex align-items-center"
                  style={{
                    ...props.style,
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    margin: "6px 12px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    className="me-3 text-muted"
                    style={{ cursor: "grab", fontSize: "18px" }}
                  >
                    ☰
                  </div>
                  <img
                    src={value.url}
                    alt={`carousel-${index}`}
                    style={{
                      width: 140,
                      height: 90,
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                  <span className="ms-3 flex-grow-1 text-muted">
                     #{index + 1}
                  </span>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(value._id)}
                  >
                    🗑 Delete
                  </button>
                </li>
              )}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Carousel_setup;
